import { ActionType } from 'types/redux';

export const SET_CURRENT_STORE_FRONT = 'STORE_FRONTS/SET_CURRENT_STORE_FRONT';

export const setCurrentStoreFront = (
	payload: IStoreFront | undefined
): ActionType => {
	return { type: SET_CURRENT_STORE_FRONT, payload };
};
